import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=3dea3a94&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"
import style0 from "./newsList.vue?vue&type=style&index=0&id=3dea3a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea3a94",
  null
  
)

export default component.exports